import React, { Component } from 'react';
import clientApi from '../../api/client';
import UA from '../../utils/ua';

import './style.less';

export default class WebViewHeader extends Component {
    constructor (props) {
        super(props);
        this.isMobile = UA.mobileClient;
    }

    handleClose = () => {
        clientApi.closeH5Page({ reason: "closeSafe" })
    }

    handleBack = () => {
        window.history.back();
    }

    render(){
        const { title, showBack, showClose, background } = this.props;
        return(
            <div className={ `title_wrap ${this.isMobile ? '' : 'pc' }`} style={{ background }}>
                { showBack && <div className="btn back" onClick={ this.handleBack }></div> }
                { title && <h3>{ this.props.title }</h3> }
                { showClose && <div className="btn close" onClick={ this.handleClose }></div> }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/template/WebViewHeader/WebViewHeader.jsx